import { ApiResponse } from '@core/interface/api-response.interface';
import { PageableResponse } from '@core/interface/pageable.interface';
import { Observable } from 'rxjs';
import { ListManagementScheduleExecutionRequestDto } from '../dtos/list-management-schedule-execution.request.dto';
import { ManagementScheduleExecutionResponseDto } from '../dtos/management-schedule-execution.response.dto';

export abstract class ManagementScheduleExecutionRepository {
  abstract list(
    request: ListManagementScheduleExecutionRequestDto,
  ): Observable<
    ApiResponse<PageableResponse<ManagementScheduleExecutionResponseDto>>
  >;
}
